/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getEspecialties } from 'app/entities/especialty/especialty.reducer';
import { getEntities as getHospitalProcedures } from 'app/entities/hospital-procedure/hospital-procedure.reducer';
import { createEntity, getEntity, reset, updateEntity } from './hospital-procedure-speciality.reducer';

export const HospitalProcedureSpecialityUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const especialties = useAppSelector(state => state.especialty.entities);
  const hospitalProcedures = useAppSelector(state => state.hospitalProcedure.entities);
  const hospitalProcedureSpecialityEntity = useAppSelector(state => state.hospitalProcedureSpeciality.entity);
  const loading = useAppSelector(state => state.hospitalProcedureSpeciality.loading);
  const updating = useAppSelector(state => state.hospitalProcedureSpeciality.updating);
  const updateSuccess = useAppSelector(state => state.hospitalProcedureSpeciality.updateSuccess);

  const handleClose = () => {
    navigate(`/hospital-procedure-speciality${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getEspecialties({}));
    dispatch(getHospitalProcedures({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastUpdate !== undefined && typeof values.lastUpdate !== 'number') {
      values.lastUpdate = Number(values.lastUpdate);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampEntry !== undefined && typeof values.timestampEntry !== 'number') {
      values.timestampEntry = Number(values.timestampEntry);
    }

    const entity = {
      ...hospitalProcedureSpecialityEntity,
      ...values,
      speciality: especialties.find(it => it.id.toString() === values.speciality?.toString()),
      procedure: hospitalProcedures.find(it => it.id.toString() === values.procedure?.toString()),
      hospitalProcedure: hospitalProcedures.find(it => it.id.toString() === values.hospitalProcedure?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...hospitalProcedureSpecialityEntity,
          speciality: hospitalProcedureSpecialityEntity?.speciality?.id,
          procedure: hospitalProcedureSpecialityEntity?.procedure?.id,
          hospitalProcedure: hospitalProcedureSpecialityEntity?.hospitalProcedure?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2
            id="tinyMedicRestApp.hospitalProcedureSpeciality.home.createOrEditLabel"
            data-cy="HospitalProcedureSpecialityCreateUpdateHeading"
          >
            <Translate contentKey="tinyMedicRestApp.hospitalProcedureSpeciality.home.createOrEditLabel">
              Create or edit a HospitalProcedureSpeciality
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="hospital-procedure-speciality-id"
                  label={translate('tinyMedicRestApp.hospitalProcedureSpeciality.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.hospitalProcedureSpeciality.active')}
                id="hospital-procedure-speciality-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.hospitalProcedureSpeciality.cursor')}
                id="hospital-procedure-speciality-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.hospitalProcedureSpeciality.lastUpdate')}
                id="hospital-procedure-speciality-lastUpdate"
                name="lastUpdate"
                data-cy="lastUpdate"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.hospitalProcedureSpeciality.microSec')}
                id="hospital-procedure-speciality-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.hospitalProcedureSpeciality.timestampEntry')}
                id="hospital-procedure-speciality-timestampEntry"
                name="timestampEntry"
                data-cy="timestampEntry"
                type="text"
              />
              <ValidatedField
                id="hospital-procedure-speciality-speciality"
                name="speciality"
                data-cy="speciality"
                label={translate('tinyMedicRestApp.hospitalProcedureSpeciality.speciality')}
                type="select"
              >
                <option value="" key="0" />
                {especialties
                  ? especialties.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="hospital-procedure-speciality-procedure"
                name="procedure"
                data-cy="procedure"
                label={translate('tinyMedicRestApp.hospitalProcedureSpeciality.procedure')}
                type="select"
              >
                <option value="" key="0" />
                {hospitalProcedures
                  ? hospitalProcedures.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="hospital-procedure-speciality-hospitalProcedure"
                name="hospitalProcedure"
                data-cy="hospitalProcedure"
                label={translate('tinyMedicRestApp.hospitalProcedureSpeciality.hospitalProcedure')}
                type="select"
              >
                <option value="" key="0" />
                {hospitalProcedures
                  ? hospitalProcedures.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button
                tag={Link}
                id="cancel-save"
                data-cy="entityCreateCancelButton"
                to="/hospital-procedure-speciality"
                replace
                color="info"
              >
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default HospitalProcedureSpecialityUpdate;
